import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

/**
 * Mantém o Leaflet ciente do tamanho real do container.
 *
 * O Leaflet calcula o viewport UMA vez, na montagem. Se o container muda de altura
 * depois (expandir/recolher o mapa, painel que abre, troca de aba), ele continua
 * desenhando tiles só na área antiga e o resto fica cinza. `invalidateSize()` força
 * o recálculo — aqui via ResizeObserver, então funciona para qualquer causa de
 * redimensionamento, inclusive durante a transição de CSS.
 */
const MapAutoResize: React.FC = () => {
    const map = useMap();

    useEffect(() => {
        const el = map.getContainer();
        const invalidate = () => map.invalidateSize({ animate: false });

        const ro = new ResizeObserver(invalidate);
        ro.observe(el);

        // Primeira passada depois do layout assentar (container pode montar com 0px).
        const t = setTimeout(invalidate, 100);
        window.addEventListener('resize', invalidate);

        return () => {
            ro.disconnect();
            clearTimeout(t);
            window.removeEventListener('resize', invalidate);
        };
    }, [map]);

    return null;
};

export default MapAutoResize;
